/* eslint @typescript-eslint/naming-convention: 0 */

export interface SelectTagInSearchModalParams {
  tag_name: string;
}

export const buildSelectTagInSearchModalParams = (tag: string): SelectTagInSearchModalParams => {
  return {
    tag_name: tag,
  };
};
